import axios from 'axios'

import Cookies from 'js-cookie';

// import dashboardData from './mock/dashboard.json'
// import viewActivityData from './mock/view-activity.json'
// import manageUsersData from './mock/manage-users.json'
// import userPicture from './mock/user-picture.json'

const TOKEN_COOKIE = '_ssoToken';

const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
        'Content-Type': 'application/json',
        'VLR-Authorization': btoa(JSON.stringify({ "id": process.env.REACT_APP_ID }))
    }
})

instance.interceptors.request.use (
    request => {
        const idToken = Cookies.get(TOKEN_COOKIE);
        if (!idToken) {
            request.cancelToken = new axios.CancelToken((cancel) => cancel('Token Expired'));
        } else {
            request.headers['Authorization'] = idToken;
        }
        return request
    },
    error => {
      return Promise.reject(error)
    }
)

const requests = {
    getReport: async (id: string) => {
        try {
            // return dashboardData;
            const response = await instance.get('/report/'+id)
            return response
        } catch (error) {
            throw error;
        }
    },
    getDashboardData: async () => {
        try {
            // return dashboardData;
            const response = await instance.post('/dashboard/application', {})
            return response
        } catch (error) {
            throw error;
        }
    },
    getViewActivityData: async (id: string) => {
        try {
            // return viewActivityData.find(x => x.id === id);
            const response = await instance.post('/dashboard/view-activity', {applicationId: id})
            return response
        } catch (error) {
            throw error;
        }
    },
    getManageUsersData: async (id: string) => {
        try {
            // return manageUsersData;
            // const response = await instance.get('/manager-users/'+id)
            const response = await instance.post('/dashboard/user', {applicationId: id})
            return response
        } catch (error) {
            throw error;
        }
    },
    getSearchUsersData: async (searchText: string) => {
        try {
            // const response = manageUsersData.filter(user => 
            //     (user.firstName && user.firstName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
            //     (user.lastName && user.lastName.toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
            //     ((user.firstName && user.lastName) && (user.firstName + ' ' + user.lastName).toLowerCase().indexOf(searchText.toLowerCase()) !== -1) ||
            //     (user.email && user.email.indexOf(searchText.toLowerCase()) !== -1)
            // );
            const response = await instance.post('/dashboard/user', {search: searchText})
            return response
        } catch (error) {
            throw error;
        }
    },
    getUserData: async (applicationId: string, userId: string) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {get: {userId: userId, applicationId: applicationId}})
            return response
        } catch (error) {
            throw error;
        }
    },
    getRequestUserData: async (applicationId: string, ids: Array<string>) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {request: {applicationId: applicationId, users: ids}})
            return response
        } catch (error) {
            throw error;
        }
    },
    saveUserData: async (data: any) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {save: data})
            return response
        } catch (error) {
            throw error;
        }
    },
    removeUserData: async (id: string) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {remove: id})
            return response
        } catch (error) {
            throw error;
        }
    },
    applyUserData: async (data: Array<any>) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {apply: data})
            return response
        } catch (error) {
            throw error;
        }
    },
    resetUserPassword: async (email: string) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {reset: email})
            return response
        } catch (error) {
            throw error;
        }
    },
    changeUserAppStatus: async (id: string, applicationId: string, inactive: boolean) => {
        try {
            // return manageUsersData.find(user => user.id === id);
            const response = await instance.post('/dashboard/user', {changeAppStatus: {id: id, applicationId: applicationId, inactive: inactive}})
            return response
        } catch (error) {
            throw error;
        }
    },
    getUserPicture: async (id: string) => {
        try {
            // return userPicture[id];
            const response = await instance.post('/dashboard/user-picture', {userId: id})
            return response
        } catch (error) {
            throw error;
        }
    },    
    uploadUserPicture: async (upload) => {
        try {
            // return userPicture[id];
            const response = await instance.post('/dashboard/user-picture', upload)
            return response
        } catch (error) {
            throw error;
        }
    }


}
export default requests
